var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.mValues),function(dictEntry){return _c('el-tag',{key:dictEntry.id,attrs:{"size":"mini"}},[_vm._v(_vm._s(dictEntry.value))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }